import CustomCopy from '../CustomCopy/CustomCopy'
import * as Styles from '../styles'
import CopyPreview from './CopyPreview/CopyPreview'

const CopyTabContent = ({
  copies,
  selectedTab,
  activePreview,
  onPreviewChange,
  language,
  previewLanguage,
  errors,
  onChangeCopy,
  supportedLanguages,
  customCopies,
  isCustomCopyActive,
  onChangeIsActive,
  onLanguageChange,
  returnsPortalUrl,
  merchantInfo,
  address,
  loading,
}) => (
  <Styles.ContentLayout>
    <Styles.LeftColumn>
      <Styles.GroupContainer>
        {copies.map(copy => (
          <Styles.CopySection key={copy?.key}>
            <CustomCopy
              copy={copy}
              lang={language}
              errors={errors}
              onChangeCopy={onChangeCopy}
              supportedLanguages={supportedLanguages}
              customCopies={customCopies}
              isCustomCopyActive={isCustomCopyActive(copy?.key)}
              onChangeIsActive={onChangeIsActive}
              activePreview={activePreview}
              onPreviewChange={onPreviewChange}
              onLanguageChange={onLanguageChange}
              merchantInfo={merchantInfo}
              loading={loading}
            />
          </Styles.CopySection>
        ))}
      </Styles.GroupContainer>
    </Styles.LeftColumn>
    <Styles.RightColumn>
      <CopyPreview
        selectedTab={selectedTab}
        activePreview={activePreview}
        customCopies={customCopies}
        lang={previewLanguage}
        returnsPortalUrl={returnsPortalUrl}
        merchantInfo={merchantInfo}
        address={address}
        isCustomCopyActive={isCustomCopyActive}
      />
    </Styles.RightColumn>
  </Styles.ContentLayout>
)

export default CopyTabContent
